/**
 * Score a command label against a query string.
 *
 * - Empty query → 1.0 (show everything)
 * - Exact match (case-insensitive) → 1.0
 * - Prefix match → 0.9
 * - Word-boundary match → 0.8
 * - Contiguous substring match → 0.6
 * - Subsequence match → 0.1–0.4 scaled by match ratio
 * - No match → 0.0 (excluded)
 */
export function scoreCommand(query: string, label: string): number {
    if (!query) return 1.0;

    const lowerQuery = query.toLowerCase();
    const lowerLabel = label.toLowerCase();

    if (lowerQuery === lowerLabel) return 1.0;

    if (lowerLabel.startsWith(lowerQuery)) return 0.9;

    // Word-boundary match: query matches start of any word in label
    const words = lowerLabel.split(/\s+/);
    if (words.some((word) => word.startsWith(lowerQuery))) return 0.8;

    // Contiguous substring
    if (lowerLabel.includes(lowerQuery)) return 0.6;

    // Subsequence match
    let qi = 0;
    for (let li = 0; li < lowerLabel.length && qi < lowerQuery.length; li++) {
        if (lowerLabel[li] === lowerQuery[qi]) qi++;
    }

    if (qi === lowerQuery.length) {
        const ratio = lowerQuery.length / lowerLabel.length;
        return 0.1 + 0.3 * ratio;
    }

    return 0.0;
}
